import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const moveRight = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

const LoadingOverlay = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8fafc;
  position: relative;
  overflow: hidden;
`;

const Cloud = styled.div<{ delay: number; duration: number; opacity: number }>`
  position: absolute;
  width: 200px;
  height: 60px;
  background: linear-gradient(90deg, transparent, rgba(176, 196, 222, ${p => p.opacity}), transparent);
  filter: blur(20px);
  animation: ${moveRight} ${p => p.duration}s linear infinite;
  animation-delay: ${p => p.delay}s;
  transform: translateX(-100%);
`;

const LoadingText = styled.div`
  font-size: 1.5rem;
  color: #2d3748;
  z-index: 1;
  font-weight: 500;
  opacity: 0.8;
`;

function LoadingScreen() {
  return (
    <LoadingOverlay>
      <LoadingText>Loading...</LoadingText>
      {/* Multiple clouds with different speeds, sizes, and opacities */}
      <Cloud delay={0} duration={4} opacity={0.3} />
      <Cloud delay={2} duration={6} opacity={0.2} />
      <Cloud delay={1} duration={5} opacity={0.15} />
      <Cloud delay={3} duration={7} opacity={0.25} />
      <Cloud delay={2.5} duration={5.5} opacity={0.2} />
    </LoadingOverlay>
  );
}

export default LoadingScreen; 